import type { PhoningLocale } from "@/locales/fr/phoning";

import { EndCallStatus } from "@/domains/voltacall/voltacall.types";

const endCallStatusOptions: Record<EndCallStatus, string> = {
  [EndCallStatus.CONFIRM_ELIGIBILITY]: "Confirm eligibility",
  [EndCallStatus.NO_TECHNICIAN_AVAILABILITY]: "No technician availability",
  [EndCallStatus.NO_SUBSCRIBER_AVAILABILITY]: "No subscriber availability",
  [EndCallStatus.SUBSCRIPTION_FAILURE]: "Subscription failure",
  [EndCallStatus.UNREACHABLE]: "Unreachable",
  [EndCallStatus.SIMPLE_CONSULTATION]: "Simple consultation",
};

const phoningLocale: PhoningLocale = {
  phoning: {
    closeCall: "Close call",
    processingType: "Processing type",
    contactReason: "Contact reason",
    simpleConsultation: "Simple consultation",
    endCallStatus: "End-call status",
    endCallStatusOptions,
    failureReason: "Failure reason",
    additionalPlanningClosure: "Additional planning closure",
    additionalPlanningClosureDescription: "Declare an event other than the one associated with the end-call status.",
    closeEventReason: "Event",
    endCallStatusCategories: {
      success: "Success",
      availability: "Availability",
      failure: "Failure",
    },
  },
};

export default phoningLocale;
